import { render, staticRenderFns } from "./Ativo.vue?vue&type=template&id=252ab196&scoped=true"
import script from "./Ativo.vue?vue&type=script&lang=js"
export * from "./Ativo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252ab196",
  null
  
)

export default component.exports